import { z } from 'zod';

export const ShopperTokenDTO = z.object({
    token: z.object({
        accessToken: z.string(),
        refreshToken: z.string(),
        type: z.string(),
        customerId: z.string(),
        expiresIn: z.number(),
    }),
});

export const DecodedAccessTokenDTO = z.object({
    body: z.object({
        shopperId: z.string(),
    }),
});

export type DecodedAccessTokenDTO = z.infer<typeof DecodedAccessTokenDTO>;
export type ShopperTokenDTO = z.infer<typeof ShopperTokenDTO>;
